import { useEffect } from "react";
import { useInterval } from "react-interval-hook";

const useTimeout = (callback, delay) => {
  const { start } = useInterval(
    () => {
      callback();
    },
    delay,
    {
      autoStart: false,
      immediate: false,
      executeOnlyOnce: true,
    }
  );

  useEffect(() => {
    if (delay !== null) {
      start();
    }
  }, [delay, start]);
};

export default useTimeout;
